// @ts-ignore
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
export const NonSkuPriceRangeFragmentDoc = gql`
    fragment nonSkuPriceRange on NonSkuPriceRange {
  __typename
  min {
    ...money
  }
  max {
    ...money
  }
}
    ${MoneyFragmentDoc}`;